module.exports = __webpack_public_path__ + "img/logo-WC-black.8be40d47.png";